
import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../_services/auth.service';
import { GuestService } from './../../_services/guest.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  iData:any=undefined

  imageOneDescription="Colorful math learning for Primary 1 students – fun counting games, number recognition, and basic addition activities designed for early learners."

imageTwoDescription="Engaging Primary 2 math lessons - simple addition, subtraction, and number patterns with child-friendly visuals to build strong foundational skills."

imageThreeDescription="Interactive Primary 3 math practice – explore multiplication, division basics, and measurement activities in a playful and educational setting."

imageFourDescription="Creative Primary 4 mathematics -  develop skills in fractions, geometry, and real-life word problems through fun, curriculum-based challenges."

imageFiveDescription="Smart learning for Primary 5 – master advanced operations, decimals, and angles with engaging online math tools tailored for upper primary learners."

imageSixDescription="Comprehensive Primary 6 math content – prepare for exams with topics on ratio, percentage, algebra, and complex word problems in an intuitive format."

imageSevenDescription="Exam-ready Primary 7 mathematics – complete revision of the primary curriculum including probability, statistics, and preparation for national assessments."

  constructor(public authService:AuthService, private guestService:GuestService) { }
  ngOnInit(): void {
    this.loadIData()
  }
  downloadapp(){
    window.location.href = 'https://play.google.com/store/apps/details?id=com.boldungu.boldlet';
   }

   loadIData(){
    this.guestService.iData.subscribe(
      myData=>{
        if(myData){
          this.iData=myData
        }else{
          this.guestService.getIDataDefault().subscribe(
            myData2=>{
              this.iData=myData2

            }
          )
        }
      }
    )
   }

}

